import { ApolloError } from '@apollo/client';

const consolidateKnownErrors = (error: ApolloError): Record<string, string> | undefined => {
  if (!error.graphQLErrors?.length) {
    return;
  }

  // find any error that has `extensions.known_errors`
  // merge all of the known errors into a single object
  return error.graphQLErrors.reduce<Record<string, string> | undefined>((acc, graphQLError) => {
    if (!graphQLError.extensions?.known_errors) {
      return acc;
    }

    return {
      ...acc,
      ...graphQLError.extensions.known_errors,
    };
  }, undefined);
};

export default consolidateKnownErrors;
